import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useAuth0 } from '@auth0/auth0-react';
import { useHistory } from 'react-router-dom';
import Loading from '../Loading';

const StyledCallback = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  flex-direction: column;
`;

const Callback = () => {
  const { isLoading, isAuthenticated, error, user } = useAuth0();
  const history = useHistory();

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        // Redirect to home page after successful authentication
        history.replace('/');
      } else if (error) {
        // Redirect to login page if there's an error
        history.replace('/login');
      } else {
        // If not authenticated and no error, redirect to login
        history.replace('/login');
      }
    }
  }, [isLoading, isAuthenticated, error, history, user]);

  return (
    <StyledCallback>
      <Loading />
      <h1>Logging in...</h1>
    </StyledCallback>
  );
};

export default Callback;
